// extracted by mini-css-extract-plugin
export default {"strong":"yield_strong__H0nT-"};